module.exports = __webpack_public_path__ + "videos/32.0565edc.mp4";